import BaseCurve from './BaseCurve';

export default class CosCurve extends BaseCurve {
  // eslint-disable-next-line class-methods-use-this
  evaluate(start: number[], end: number[], t: number): number {
    // Reference: http://paulbourke.net/miscellaneous/interpolation/
    const t1 = (1 - Math.cos(t * Math.PI)) / 2;
    return (start[1] * (1 - t1) + end[1] * t1);
  }

  // eslint-disable-next-line class-methods-use-this
  evaluateDerivative(start: number[], end: number[], t: number): number {
    const piT = t * Math.PI;
    return Math.PI * Math.sin(piT) * (end[1] - start[1] * Math.cos(piT));
  }

  clone(): CosCurve {
    return new CosCurve(this.controls);
  }
}
